import { Icon } from "@material-ui/core";
import IconّF from 'react-native-vector-icons/FontAwesome';
import React, { Component, useRef, useEffect, useState } from "react";
import {
    StyleSheet, View, Text, TouchableOpacity, Image, ScrollView,
    Animated,
    SafeAreaView,
    ImageBackground,
    Dimensions, Platform, I18nManager
} from "react-native";
import useInternetStatus from "../Components/useInternetStatus";
import { useNavigation } from '@react-navigation/native';
import { Props } from "react-native-image-zoom-viewer/built/image-viewer.type";

import { useTranslation } from 'react-i18next';
import {i18n} from "../assets/lang/i18next";
const dimensions = Dimensions.get('window');
const imageHeight = Math.round(dimensions.width * 9 / 16);
const imageWidth = dimensions.width;

const images = [
    require("../assets/images/dashboardslider/1.jpg"),
    require("../assets/images/dashboardslider/2.jpg"),
    require("../assets/images/dashboardslider/4.jpg"),
    require("../assets/images/dashboardslider/3.jpg"),
]



const Dashboard = ({ navigation }) => {
    const scrollX = React.useRef(new Animated.Value(0)).current;
    const { t, i18n } = useTranslation();
    const isInternetReachable = useInternetStatus();

    return (

        <ScrollView style={styles.scroll}>
            <View style={styles.container}>
                <Image source={{uri: 'https://app.arshehkar.com/gallery/banner/slider.png'}} resizeMode="stretch"      style={{ height: imageHeight, width: imageWidth }}
 />
                <View style={{ flexDirection: 'column', justifyContent: 'center', padding: 0,marginBottom:100 }}>

                    <Image source={require('../assets/images/dashboardslider/boom.png')} resizeMode="contain" style={{ height: 150, flex: 1, width: null }} />
                </View>
                

            </View>
        </ScrollView >

    )
}
const styles = StyleSheet.create({

    scroll: {
        backgroundColor: '#0b4660', height: "100%",
    },
    container: {
        flexDirection: 'column',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',

        marginBottom: 0, backgroundColor: '#0b4660'
    }
    , banner:
    {

        resizeMode: 'contain',
        justifyContent: 'center',
        marginBottom: 50,
        ...Platform.select({
            ios: {
                width: '100%', height: (dimensions.width >= 500 ? 400 : 50),
            },
            android: {
                width: '100%', height: (dimensions.width >= 500 ? 400 : 50),
            },
            default: {
                width: '100%', height: (dimensions.width >= 500 ? 400 : 50),
            }
        })

    }

})
export default Dashboard;